import { COLORS } from '../constants/theme';
import { SectionHeader } from './ui/SectionHeader';
import type { CrystalEyeData } from '../types/intel';

interface CrystalEyeResultProps {
  runesConsumed: number;
  manaConsumed: number;
  data: CrystalEyeData;
}

/**
 * SF-91d: Real-time Crystal Eye result. Renders the kingdom event log payload
 * carried alongside the cast result — no async fetch needed.
 */
export function CrystalEyeResult({ runesConsumed, manaConsumed, data }: CrystalEyeResultProps) {
  const eventCount = data.events.length;

  return (
    <div
      className="border p-4"
      style={{ backgroundColor: COLORS.card, borderColor: COLORS.border }}
    >
      <SectionHeader title={`Crystal Eye — ${data.kingdomName} (${data.location})`} />

      <p className="text-xs mb-3" style={{ color: COLORS.text.muted }}>
        Lookback: days {data.fromTick}–{data.toTick}
        {' · '}
        Cost: {runesConsumed} runes, {manaConsumed.toFixed(1)} mana
      </p>

      {eventCount === 0 ? (
        <p className="text-sm italic" style={{ color: COLORS.text.muted }}>
          No notable events in the lookback window.
        </p>
      ) : (
        <ul className="space-y-1 text-sm" style={{ color: COLORS.text.primary }}>
          {data.events.map((entry, idx) => (
            <li
              key={idx}
              className="flex gap-2"
              data-testid="crystal-eye-event"
              data-category={entry.category}
            >
              <span
                className="font-mono text-xs whitespace-nowrap"
                style={{ color: COLORS.text.muted }}
              >
                {entry.tick}
              </span>
              <span>{entry.summary}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
